export class FieldDetailModel {
    public id: number;
    public name: string;
    public description: string;
    public isRequired: boolean;
}